import { AxiosError, AxiosResponse } from "axios";
import * as R from "ramda";

export type AxiosInterceptedResult<T> = [string, null] | [null, AxiosResponse<T>];

export function interceptSuccess<T>(response: AxiosResponse): Promise<AxiosInterceptedResult<T>> {
  // For certain requests the backend lies and response.status is 200 when response.data
  // contains an error, so we need to check if an error is hiding in response.data.
  const responseStatus: number = R.pathOr(response.status, ["data", "status"], response);
  if (responseStatus >= 400) {
    const errorMsg: string = R.pathOr(response.statusText, ["data", "error"], response);
    return Promise.resolve([errorMsg, null]);
  }

  return Promise.resolve([null, response]);
}

export function interceptError<T>(error: AxiosError): Promise<AxiosInterceptedResult<T>> {
  return Promise.resolve([error.message, null]);
}
